function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 706;


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/ChineseNewYear nonrecursive \.(png|jpe?g|svg)$
// module id = 706
// module chunks = 0